import { PinkRectangle } from "../styles/Images";
import { EventsWrapper } from "../styles/Layouts";
import { StripeMessage } from "../styles/Typography";

const Cancel = () => {
  return (
    <EventsWrapper>
      <PinkRectangle>
        <StripeMessage>Sorry to see you cancelled your Stripe payment!</StripeMessage>
      </PinkRectangle>
    </EventsWrapper>
  );
};

export default Cancel;
